import { configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage'


import CustomerReducer from "./redux/CustomerReducer";

import DriverReducer from "./redux/DriverReducer";

import AdminReducer from "./redux/AdminReducer";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
}

const persistedReducer = persistReducer(persistConfig, AdminReducer);
const CustomerReducerPersistance = persistReducer(persistConfig, CustomerReducer);
const DriverReducerPersistance = persistReducer(persistConfig, DriverReducer);

 const store = configureStore({
  reducer:{AdminReducer:persistedReducer,CustomerReducer:CustomerReducerPersistance,DriverReducer:DriverReducerPersistance},
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})



export default store;